import { makeStyles, Paper, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { SchedaBudgetInputProps } from './InformazioniCosti';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         root: {
//             flexGrow: 1,
//         },
//         label: {
//             marginTop: "1rem"
//         },
//         boldLabel: {
//             marginTop: "1rem",
//             fontWeight: 900
//         }
//     }),
// );

export default function DettagliImpresaFamiliare(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const { state } = props;
    // const classes = useStyles();

    return (
        <Paper className={gClasses.mainPaper}>
            <SectionSubTitle style={{ cursor: "pointer" }} className={gClasses.boldLabel} text="Impresa famigliare"></SectionSubTitle>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Titolare</Typography>
                <NumberField
                    name="D7_quota"
                    label="Quota"
                    value={state.dettagli.D7_quota}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    symbol="%"
                />
                <NumberField
                    name="E7_contributi"
                    label="Contributi"
                    value={state.dettagli.E7_contributi}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="F7_irpef_add"
                    label="IRPEF/Add."
                    value={state.dettagli.F7_irpef_add}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Collaboratore</Typography>
                <NumberField
                    name="D8_quota"
                    label="Quota"
                    value={state.dettagli.D8_quota}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    symbol="%"
                />
                <NumberField
                    name="E8_contributi"
                    label="Contributi"
                    value={state.dettagli.E8_contributi}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="F8_irpef_add"
                    label="IRPEF/Add."
                    value={state.dettagli.F8_irpef_add}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Collaboratore</Typography>
                <NumberField
                    name="D9_quota"
                    label="Quota"
                    value={state.dettagli.D9_quota}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    symbol="%"
                />
                <NumberField
                    name="E9_contributi"
                    label="Contributi"
                    value={state.dettagli.E9_contributi}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="F9_irpef_add"
                    label="IRPEF/Add."
                    value={state.dettagli.F9_irpef_add}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Collaboratore</Typography>
                <NumberField
                    name="D10_quota"
                    label="Quota"
                    value={state.dettagli.D10_quota}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    symbol="%"
                />
                <NumberField
                    name="E10_contributi"
                    label="Contributi"
                    value={state.dettagli.E10_contributi}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="F10_irpef_add"
                    label="IRPEF/Add."
                    value={state.dettagli.F10_irpef_add}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Collaboratore</Typography>
                <NumberField
                    name="D11_quota"
                    label="Quota"
                    value={state.dettagli.D11_quota}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    symbol="%"
                />
                <NumberField
                    name="E11_contributi"
                    label="Contributi"
                    value={state.dettagli.E11_contributi}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="F11_irpef_add"
                    label="IRPEF/Add."
                    value={state.dettagli.F11_irpef_add}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Totale</Typography>
                <NumberField
                    name="D12_quota"
                    label="Quota"
                    value={state.dettagli.D12_quota}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    symbol="%"
                />
                <NumberField
                    name="E12_contributi"
                    label="Contributi"
                    value={state.dettagli.E12_contributi}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="F12_irpef_add"
                    label="IRPEF/Add."
                    value={state.dettagli.F12_irpef_add}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
        </Paper>
    )
}